import React from "react";
import { Navigate } from "react-router-dom";
import { getSecureItem } from "../services/SecureStorage";

const PrivateRoute = ({ children }) => {
  const authToken = getSecureItem("authToken"); // Retrieve authToken from localStorage

  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  return children; // If authToken exists, render the children components
};

export default PrivateRoute;
